module.exports = __webpack_public_path__ + "static/media/interior4.184fef89.jpg";


//////////////////
// WEBPACK FOOTER
// /src/images/residence/interior4.jpg
// module id = 1612
// module chunks = 0